/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ScheduleIndexRouteImport } from './routes/schedule/index'
import { Route as PatientsIndexRouteImport } from './routes/patients/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TasksTaskIdRouteImport } from './routes/tasks/$taskId'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsHotkeysRouteImport } from './routes/settings/hotkeys'
import { Route as PatientsPatientIdRouteImport } from './routes/patients/$patientId'
import { Route as ChatLayoutRouteRouteImport } from './routes/chat/_layout/route'
import { Route as CatalogLayoutRouteRouteImport } from './routes/catalog/_layout/route'
import { Route as ScheduleManageIndexRouteImport } from './routes/schedule/manage/index'
import { Route as ChatLayoutIndexRouteImport } from './routes/chat/_layout/index'
import { Route as CatalogFlowsIndexRouteImport } from './routes/catalog/flows/index'
import { Route as CatalogLayoutIndexRouteImport } from './routes/catalog/_layout/index'
import { Route as TasksTaskIdReviewRouteImport } from './routes/tasks/$taskId_.review'
import { Route as ScheduleManageNewRouteImport } from './routes/schedule/manage/new'
import { Route as ScheduleManageScheduleIdRouteImport } from './routes/schedule/manage/$scheduleId'
import { Route as ChatLayoutThreadIdRouteImport } from './routes/chat/_layout/$threadId'
import { Route as CatalogTreatmentsNewRouteImport } from './routes/catalog/treatments/new'
import { Route as CatalogTreatmentsTreatmentIdRouteImport } from './routes/catalog/treatments/$treatmentId'
import { Route as CatalogQuestionnairesNewRouteImport } from './routes/catalog/questionnaires/new'
import { Route as CatalogQuestionnairesQuestionnaireIdRouteImport } from './routes/catalog/questionnaires/$questionnaireId'
import { Route as CatalogProtocolsNewRouteImport } from './routes/catalog/protocols/new'
import { Route as CatalogProtocolsProtocolIdRouteImport } from './routes/catalog/protocols/$protocolId'
import { Route as CatalogProceduresNewRouteImport } from './routes/catalog/procedures/new'
import { Route as CatalogProceduresProcedureIdRouteImport } from './routes/catalog/procedures/$procedureId'
import { Route as CatalogPerformanceMeasuresNewRouteImport } from './routes/catalog/performance-measures/new'
import { Route as CatalogPerformanceMeasuresQuestionnaireIdRouteImport } from './routes/catalog/performance-measures/$questionnaireId'
import { Route as CatalogLocationsNewRouteImport } from './routes/catalog/locations/new'
import { Route as CatalogLocationsLocationIdRouteImport } from './routes/catalog/locations/$locationId'
import { Route as CatalogFlowsNewRouteImport } from './routes/catalog/flows/new'
import { Route as CatalogFlowsFlowIdRouteImport } from './routes/catalog/flows/$flowId'
import { Route as CatalogFindingsNewRouteImport } from './routes/catalog/findings/new'
import { Route as CatalogFindingsFindingIdRouteImport } from './routes/catalog/findings/$findingId'
import { Route as CatalogExamsNewRouteImport } from './routes/catalog/exams/new'
import { Route as CatalogExamsExamIdRouteImport } from './routes/catalog/exams/$examId'
import { Route as CatalogDiagnosticsNewRouteImport } from './routes/catalog/diagnostics/new'
import { Route as CatalogDiagnosticsDiagnosticIdRouteImport } from './routes/catalog/diagnostics/$diagnosticId'
import { Route as CatalogDevicesNewRouteImport } from './routes/catalog/devices/new'
import { Route as CatalogDevicesDeviceIdRouteImport } from './routes/catalog/devices/$deviceId'
import { Route as CatalogLayoutQuestionnairesRouteImport } from './routes/catalog/_layout/questionnaires'
import { Route as CatalogLayoutProceduresRouteImport } from './routes/catalog/_layout/procedures'
import { Route as CatalogLayoutPerformanceMeasuresRouteImport } from './routes/catalog/_layout/performance-measures'
import { Route as CatalogLayoutLocationsRouteImport } from './routes/catalog/_layout/locations'
import { Route as CatalogLayoutExamsRouteImport } from './routes/catalog/_layout/exams'
import { Route as CatalogLayoutDevicesRouteImport } from './routes/catalog/_layout/devices'
import { Route as PatientsPatientIdLayoutRouteRouteImport } from './routes/patients/$patientId/_layout/route'
import { Route as PatientsPatientIdLayoutIndexRouteImport } from './routes/patients/$patientId/_layout/index'
import { Route as PatientsPatientIdDocumentsDocumentIdRouteImport } from './routes/patients/$patientId/documents/$documentId'
import { Route as PatientsPatientIdLayoutWorkbenchRouteImport } from './routes/patients/$patientId/_layout/workbench'
import { Route as CatalogTreatmentsTreatmentIdEditRouteImport } from './routes/catalog/treatments/$treatmentId_.edit'
import { Route as CatalogQuestionnairesQuestionnaireIdEditRouteImport } from './routes/catalog/questionnaires/$questionnaireId_.edit'
import { Route as CatalogProtocolsProtocolIdEditRouteImport } from './routes/catalog/protocols/$protocolId_.edit'
import { Route as CatalogProceduresProcedureIdEditRouteImport } from './routes/catalog/procedures/$procedureId_.edit'
import { Route as CatalogPerformanceMeasuresQuestionnaireIdEditRouteImport } from './routes/catalog/performance-measures/$questionnaireId_.edit'
import { Route as CatalogLocationsLocationIdEditRouteImport } from './routes/catalog/locations/$locationId_.edit'
import { Route as CatalogFindingsFindingIdEditRouteImport } from './routes/catalog/findings/$findingId_.edit'
import { Route as CatalogExamsExamIdEditRouteImport } from './routes/catalog/exams/$examId_.edit'
import { Route as CatalogDiagnosticsDiagnosticIdEditRouteImport } from './routes/catalog/diagnostics/$diagnosticId_.edit'
import { Route as CatalogDevicesDeviceIdEditRouteImport } from './routes/catalog/devices/$deviceId_.edit'
import { Route as PatientsPatientIdLayoutAssessmentsRouteRouteImport } from './routes/patients/$patientId/_layout/assessments/route'
import { Route as PatientsPatientIdLayoutVisitsIndexRouteImport } from './routes/patients/$patientId/_layout/visits/index'
import { Route as PatientsPatientIdLayoutReportsIndexRouteImport } from './routes/patients/$patientId/_layout/reports/index'
import { Route as PatientsPatientIdLayoutProfileIndexRouteImport } from './routes/patients/$patientId/_layout/profile/index'
import { Route as PatientsPatientIdLayoutNotesIndexRouteImport } from './routes/patients/$patientId/_layout/notes/index'
import { Route as PatientsPatientIdLayoutDocumentsIndexRouteImport } from './routes/patients/$patientId/_layout/documents/index'
import { Route as PatientsPatientIdLayoutCasesIndexRouteImport } from './routes/patients/$patientId/_layout/cases/index'
import { Route as PatientsPatientIdLayoutCarePlansIndexRouteImport } from './routes/patients/$patientId/_layout/care-plans/index'
import { Route as PatientsPatientIdLayoutAssessmentsIndexRouteImport } from './routes/patients/$patientId/_layout/assessments/index'
import { Route as PatientsPatientIdCarePlansCarePlanIdEditRouteImport } from './routes/patients/$patientId/care-plans/$carePlanId.edit'
import { Route as PatientsPatientIdLayoutVisitsVisitIdRouteImport } from './routes/patients/$patientId/_layout/visits/$visitId'
import { Route as PatientsPatientIdLayoutReportsReportIdRouteImport } from './routes/patients/$patientId/_layout/reports/$reportId'
import { Route as PatientsPatientIdLayoutQuestionnaireResponsesQrIdRouteImport } from './routes/patients/$patientId/_layout/questionnaire-responses/$qrId'
import { Route as PatientsPatientIdLayoutCasesCaseIdRouteImport } from './routes/patients/$patientId/_layout/cases/$caseId'
import { Route as PatientsPatientIdLayoutCarePlansCarePlanIdRouteImport } from './routes/patients/$patientId/_layout/care-plans/$carePlanId'
import { Route as PatientsPatientIdLayoutAssessmentsQInstanceIdRouteImport } from './routes/patients/$patientId/_layout/assessments/q/$instanceId'
import { Route as PatientsPatientIdLayoutAssessmentsMMeasureIdRouteImport } from './routes/patients/$patientId/_layout/assessments/m/$measureId'
import { Route as PatientsPatientIdLayoutAssessmentsEExamIdRouteImport } from './routes/patients/$patientId/_layout/assessments/e/$examId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleIndexRoute = ScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsHotkeysRoute = SettingsHotkeysRouteImport.update({
  id: '/settings/hotkeys',
  path: '/settings/hotkeys',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsPatientIdRoute = PatientsPatientIdRouteImport.update({
  id: '/patients/$patientId',
  path: '/patients/$patientId',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatLayoutRouteRoute = ChatLayoutRouteRouteImport.update({
  id: '/chat/_layout',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogLayoutRouteRoute = CatalogLayoutRouteRouteImport.update({
  id: '/catalog/_layout',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleManageIndexRoute = ScheduleManageIndexRouteImport.update({
  id: '/schedule/manage/',
  path: '/schedule/manage/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatLayoutIndexRoute = ChatLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatLayoutRouteRoute,
} as any)
const CatalogFlowsIndexRoute = CatalogFlowsIndexRouteImport.update({
  id: '/catalog/flows/',
  path: '/catalog/flows/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogLayoutIndexRoute = CatalogLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogLayoutRouteRoute,
} as any)
const TasksTaskIdReviewRoute = TasksTaskIdReviewRouteImport.update({
  id: '/tasks/$taskId_/review',
  path: '/tasks/$taskId/review',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleManageNewRoute = ScheduleManageNewRouteImport.update({
  id: '/schedule/manage/new',
  path: '/schedule/manage/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleManageScheduleIdRoute =
  ScheduleManageScheduleIdRouteImport.update({
    id: '/schedule/manage/$scheduleId',
    path: '/schedule/manage/$scheduleId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ChatLayoutThreadIdRoute = ChatLayoutThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => ChatLayoutRouteRoute,
} as any)
const CatalogTreatmentsNewRoute = CatalogTreatmentsNewRouteImport.update({
  id: '/catalog/treatments/new',
  path: '/catalog/treatments/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogTreatmentsTreatmentIdRoute =
  CatalogTreatmentsTreatmentIdRouteImport.update({
    id: '/catalog/treatments/$treatmentId',
    path: '/catalog/treatments/$treatmentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogQuestionnairesNewRoute =
  CatalogQuestionnairesNewRouteImport.update({
    id: '/catalog/questionnaires/new',
    path: '/catalog/questionnaires/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogQuestionnairesQuestionnaireIdRoute =
  CatalogQuestionnairesQuestionnaireIdRouteImport.update({
    id: '/catalog/questionnaires/$questionnaireId',
    path: '/catalog/questionnaires/$questionnaireId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogProtocolsNewRoute = CatalogProtocolsNewRouteImport.update({
  id: '/catalog/protocols/new',
  path: '/catalog/protocols/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogProtocolsProtocolIdRoute =
  CatalogProtocolsProtocolIdRouteImport.update({
    id: '/catalog/protocols/$protocolId',
    path: '/catalog/protocols/$protocolId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogProceduresNewRoute = CatalogProceduresNewRouteImport.update({
  id: '/catalog/procedures/new',
  path: '/catalog/procedures/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogProceduresProcedureIdRoute =
  CatalogProceduresProcedureIdRouteImport.update({
    id: '/catalog/procedures/$procedureId',
    path: '/catalog/procedures/$procedureId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogPerformanceMeasuresNewRoute =
  CatalogPerformanceMeasuresNewRouteImport.update({
    id: '/catalog/performance-measures/new',
    path: '/catalog/performance-measures/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogPerformanceMeasuresQuestionnaireIdRoute =
  CatalogPerformanceMeasuresQuestionnaireIdRouteImport.update({
    id: '/catalog/performance-measures/$questionnaireId',
    path: '/catalog/performance-measures/$questionnaireId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogLocationsNewRoute = CatalogLocationsNewRouteImport.update({
  id: '/catalog/locations/new',
  path: '/catalog/locations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogLocationsLocationIdRoute =
  CatalogLocationsLocationIdRouteImport.update({
    id: '/catalog/locations/$locationId',
    path: '/catalog/locations/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogFlowsNewRoute = CatalogFlowsNewRouteImport.update({
  id: '/catalog/flows/new',
  path: '/catalog/flows/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogFlowsFlowIdRoute = CatalogFlowsFlowIdRouteImport.update({
  id: '/catalog/flows/$flowId',
  path: '/catalog/flows/$flowId',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogFindingsNewRoute = CatalogFindingsNewRouteImport.update({
  id: '/catalog/findings/new',
  path: '/catalog/findings/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogFindingsFindingIdRoute =
  CatalogFindingsFindingIdRouteImport.update({
    id: '/catalog/findings/$findingId',
    path: '/catalog/findings/$findingId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogExamsNewRoute = CatalogExamsNewRouteImport.update({
  id: '/catalog/exams/new',
  path: '/catalog/exams/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogExamsExamIdRoute = CatalogExamsExamIdRouteImport.update({
  id: '/catalog/exams/$examId',
  path: '/catalog/exams/$examId',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogDiagnosticsNewRoute = CatalogDiagnosticsNewRouteImport.update({
  id: '/catalog/diagnostics/new',
  path: '/catalog/diagnostics/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogDiagnosticsDiagnosticIdRoute =
  CatalogDiagnosticsDiagnosticIdRouteImport.update({
    id: '/catalog/diagnostics/$diagnosticId',
    path: '/catalog/diagnostics/$diagnosticId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogDevicesNewRoute = CatalogDevicesNewRouteImport.update({
  id: '/catalog/devices/new',
  path: '/catalog/devices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogDevicesDeviceIdRoute = CatalogDevicesDeviceIdRouteImport.update({
  id: '/catalog/devices/$deviceId',
  path: '/catalog/devices/$deviceId',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogLayoutQuestionnairesRoute =
  CatalogLayoutQuestionnairesRouteImport.update({
    id: '/questionnaires',
    path: '/questionnaires',
    getParentRoute: () => CatalogLayoutRouteRoute,
  } as any)
const CatalogLayoutProceduresRoute = CatalogLayoutProceduresRouteImport.update({
  id: '/procedures',
  path: '/procedures',
  getParentRoute: () => CatalogLayoutRouteRoute,
} as any)
const CatalogLayoutPerformanceMeasuresRoute =
  CatalogLayoutPerformanceMeasuresRouteImport.update({
    id: '/performance-measures',
    path: '/performance-measures',
    getParentRoute: () => CatalogLayoutRouteRoute,
  } as any)
const CatalogLayoutLocationsRoute = CatalogLayoutLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => CatalogLayoutRouteRoute,
} as any)
const CatalogLayoutExamsRoute = CatalogLayoutExamsRouteImport.update({
  id: '/exams',
  path: '/exams',
  getParentRoute: () => CatalogLayoutRouteRoute,
} as any)
const CatalogLayoutDevicesRoute = CatalogLayoutDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => CatalogLayoutRouteRoute,
} as any)
const PatientsPatientIdLayoutRouteRoute =
  PatientsPatientIdLayoutRouteRouteImport.update({
    id: '/_layout',
    getParentRoute: () => PatientsPatientIdRoute,
  } as any)
const PatientsPatientIdLayoutIndexRoute =
  PatientsPatientIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdDocumentsDocumentIdRoute =
  PatientsPatientIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => PatientsPatientIdRoute,
  } as any)
const PatientsPatientIdLayoutWorkbenchRoute =
  PatientsPatientIdLayoutWorkbenchRouteImport.update({
    id: '/workbench',
    path: '/workbench',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const CatalogTreatmentsTreatmentIdEditRoute =
  CatalogTreatmentsTreatmentIdEditRouteImport.update({
    id: '/catalog/treatments/$treatmentId_/edit',
    path: '/catalog/treatments/$treatmentId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogQuestionnairesQuestionnaireIdEditRoute =
  CatalogQuestionnairesQuestionnaireIdEditRouteImport.update({
    id: '/catalog/questionnaires/$questionnaireId_/edit',
    path: '/catalog/questionnaires/$questionnaireId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogProtocolsProtocolIdEditRoute =
  CatalogProtocolsProtocolIdEditRouteImport.update({
    id: '/catalog/protocols/$protocolId_/edit',
    path: '/catalog/protocols/$protocolId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogProceduresProcedureIdEditRoute =
  CatalogProceduresProcedureIdEditRouteImport.update({
    id: '/catalog/procedures/$procedureId_/edit',
    path: '/catalog/procedures/$procedureId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogPerformanceMeasuresQuestionnaireIdEditRoute =
  CatalogPerformanceMeasuresQuestionnaireIdEditRouteImport.update({
    id: '/catalog/performance-measures/$questionnaireId_/edit',
    path: '/catalog/performance-measures/$questionnaireId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogLocationsLocationIdEditRoute =
  CatalogLocationsLocationIdEditRouteImport.update({
    id: '/catalog/locations/$locationId_/edit',
    path: '/catalog/locations/$locationId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogFindingsFindingIdEditRoute =
  CatalogFindingsFindingIdEditRouteImport.update({
    id: '/catalog/findings/$findingId_/edit',
    path: '/catalog/findings/$findingId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogExamsExamIdEditRoute = CatalogExamsExamIdEditRouteImport.update({
  id: '/catalog/exams/$examId_/edit',
  path: '/catalog/exams/$examId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogDiagnosticsDiagnosticIdEditRoute =
  CatalogDiagnosticsDiagnosticIdEditRouteImport.update({
    id: '/catalog/diagnostics/$diagnosticId_/edit',
    path: '/catalog/diagnostics/$diagnosticId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogDevicesDeviceIdEditRoute =
  CatalogDevicesDeviceIdEditRouteImport.update({
    id: '/catalog/devices/$deviceId_/edit',
    path: '/catalog/devices/$deviceId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const PatientsPatientIdLayoutAssessmentsRouteRoute =
  PatientsPatientIdLayoutAssessmentsRouteRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutVisitsIndexRoute =
  PatientsPatientIdLayoutVisitsIndexRouteImport.update({
    id: '/visits/',
    path: '/visits/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutReportsIndexRoute =
  PatientsPatientIdLayoutReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutProfileIndexRoute =
  PatientsPatientIdLayoutProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutNotesIndexRoute =
  PatientsPatientIdLayoutNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutDocumentsIndexRoute =
  PatientsPatientIdLayoutDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutCasesIndexRoute =
  PatientsPatientIdLayoutCasesIndexRouteImport.update({
    id: '/cases/',
    path: '/cases/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutCarePlansIndexRoute =
  PatientsPatientIdLayoutCarePlansIndexRouteImport.update({
    id: '/care-plans/',
    path: '/care-plans/',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutAssessmentsIndexRoute =
  PatientsPatientIdLayoutAssessmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PatientsPatientIdLayoutAssessmentsRouteRoute,
  } as any)
const PatientsPatientIdCarePlansCarePlanIdEditRoute =
  PatientsPatientIdCarePlansCarePlanIdEditRouteImport.update({
    id: '/care-plans/$carePlanId/edit',
    path: '/care-plans/$carePlanId/edit',
    getParentRoute: () => PatientsPatientIdRoute,
  } as any)
const PatientsPatientIdLayoutVisitsVisitIdRoute =
  PatientsPatientIdLayoutVisitsVisitIdRouteImport.update({
    id: '/visits/$visitId',
    path: '/visits/$visitId',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutReportsReportIdRoute =
  PatientsPatientIdLayoutReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute =
  PatientsPatientIdLayoutQuestionnaireResponsesQrIdRouteImport.update({
    id: '/questionnaire-responses/$qrId',
    path: '/questionnaire-responses/$qrId',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutCasesCaseIdRoute =
  PatientsPatientIdLayoutCasesCaseIdRouteImport.update({
    id: '/cases/$caseId',
    path: '/cases/$caseId',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutCarePlansCarePlanIdRoute =
  PatientsPatientIdLayoutCarePlansCarePlanIdRouteImport.update({
    id: '/care-plans/$carePlanId',
    path: '/care-plans/$carePlanId',
    getParentRoute: () => PatientsPatientIdLayoutRouteRoute,
  } as any)
const PatientsPatientIdLayoutAssessmentsQInstanceIdRoute =
  PatientsPatientIdLayoutAssessmentsQInstanceIdRouteImport.update({
    id: '/q/$instanceId',
    path: '/q/$instanceId',
    getParentRoute: () => PatientsPatientIdLayoutAssessmentsRouteRoute,
  } as any)
const PatientsPatientIdLayoutAssessmentsMMeasureIdRoute =
  PatientsPatientIdLayoutAssessmentsMMeasureIdRouteImport.update({
    id: '/m/$measureId',
    path: '/m/$measureId',
    getParentRoute: () => PatientsPatientIdLayoutAssessmentsRouteRoute,
  } as any)
const PatientsPatientIdLayoutAssessmentsEExamIdRoute =
  PatientsPatientIdLayoutAssessmentsEExamIdRouteImport.update({
    id: '/e/$examId',
    path: '/e/$examId',
    getParentRoute: () => PatientsPatientIdLayoutAssessmentsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/catalog': typeof CatalogLayoutRouteRouteWithChildren
  '/chat': typeof ChatLayoutRouteRouteWithChildren
  '/patients/$patientId': typeof PatientsPatientIdLayoutRouteRouteWithChildren
  '/settings/hotkeys': typeof SettingsHotkeysRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/patients/': typeof PatientsIndexRoute
  '/schedule/': typeof ScheduleIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/catalog/devices': typeof CatalogLayoutDevicesRoute
  '/catalog/exams': typeof CatalogLayoutExamsRoute
  '/catalog/locations': typeof CatalogLayoutLocationsRoute
  '/catalog/performance-measures': typeof CatalogLayoutPerformanceMeasuresRoute
  '/catalog/procedures': typeof CatalogLayoutProceduresRoute
  '/catalog/questionnaires': typeof CatalogLayoutQuestionnairesRoute
  '/catalog/devices/$deviceId': typeof CatalogDevicesDeviceIdRoute
  '/catalog/devices/new': typeof CatalogDevicesNewRoute
  '/catalog/diagnostics/$diagnosticId': typeof CatalogDiagnosticsDiagnosticIdRoute
  '/catalog/diagnostics/new': typeof CatalogDiagnosticsNewRoute
  '/catalog/exams/$examId': typeof CatalogExamsExamIdRoute
  '/catalog/exams/new': typeof CatalogExamsNewRoute
  '/catalog/findings/$findingId': typeof CatalogFindingsFindingIdRoute
  '/catalog/findings/new': typeof CatalogFindingsNewRoute
  '/catalog/flows/$flowId': typeof CatalogFlowsFlowIdRoute
  '/catalog/flows/new': typeof CatalogFlowsNewRoute
  '/catalog/locations/$locationId': typeof CatalogLocationsLocationIdRoute
  '/catalog/locations/new': typeof CatalogLocationsNewRoute
  '/catalog/performance-measures/$questionnaireId': typeof CatalogPerformanceMeasuresQuestionnaireIdRoute
  '/catalog/performance-measures/new': typeof CatalogPerformanceMeasuresNewRoute
  '/catalog/procedures/$procedureId': typeof CatalogProceduresProcedureIdRoute
  '/catalog/procedures/new': typeof CatalogProceduresNewRoute
  '/catalog/protocols/$protocolId': typeof CatalogProtocolsProtocolIdRoute
  '/catalog/protocols/new': typeof CatalogProtocolsNewRoute
  '/catalog/questionnaires/$questionnaireId': typeof CatalogQuestionnairesQuestionnaireIdRoute
  '/catalog/questionnaires/new': typeof CatalogQuestionnairesNewRoute
  '/catalog/treatments/$treatmentId': typeof CatalogTreatmentsTreatmentIdRoute
  '/catalog/treatments/new': typeof CatalogTreatmentsNewRoute
  '/chat/$threadId': typeof ChatLayoutThreadIdRoute
  '/schedule/manage/$scheduleId': typeof ScheduleManageScheduleIdRoute
  '/schedule/manage/new': typeof ScheduleManageNewRoute
  '/tasks/$taskId/review': typeof TasksTaskIdReviewRoute
  '/catalog/': typeof CatalogLayoutIndexRoute
  '/catalog/flows/': typeof CatalogFlowsIndexRoute
  '/chat/': typeof ChatLayoutIndexRoute
  '/schedule/manage/': typeof ScheduleManageIndexRoute
  '/patients/$patientId/assessments': typeof PatientsPatientIdLayoutAssessmentsRouteRouteWithChildren
  '/catalog/devices/$deviceId/edit': typeof CatalogDevicesDeviceIdEditRoute
  '/catalog/diagnostics/$diagnosticId/edit': typeof CatalogDiagnosticsDiagnosticIdEditRoute
  '/catalog/exams/$examId/edit': typeof CatalogExamsExamIdEditRoute
  '/catalog/findings/$findingId/edit': typeof CatalogFindingsFindingIdEditRoute
  '/catalog/locations/$locationId/edit': typeof CatalogLocationsLocationIdEditRoute
  '/catalog/performance-measures/$questionnaireId/edit': typeof CatalogPerformanceMeasuresQuestionnaireIdEditRoute
  '/catalog/procedures/$procedureId/edit': typeof CatalogProceduresProcedureIdEditRoute
  '/catalog/protocols/$protocolId/edit': typeof CatalogProtocolsProtocolIdEditRoute
  '/catalog/questionnaires/$questionnaireId/edit': typeof CatalogQuestionnairesQuestionnaireIdEditRoute
  '/catalog/treatments/$treatmentId/edit': typeof CatalogTreatmentsTreatmentIdEditRoute
  '/patients/$patientId/workbench': typeof PatientsPatientIdLayoutWorkbenchRoute
  '/patients/$patientId/documents/$documentId': typeof PatientsPatientIdDocumentsDocumentIdRoute
  '/patients/$patientId/': typeof PatientsPatientIdLayoutIndexRoute
  '/patients/$patientId/care-plans/$carePlanId': typeof PatientsPatientIdLayoutCarePlansCarePlanIdRoute
  '/patients/$patientId/cases/$caseId': typeof PatientsPatientIdLayoutCasesCaseIdRoute
  '/patients/$patientId/questionnaire-responses/$qrId': typeof PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute
  '/patients/$patientId/reports/$reportId': typeof PatientsPatientIdLayoutReportsReportIdRoute
  '/patients/$patientId/visits/$visitId': typeof PatientsPatientIdLayoutVisitsVisitIdRoute
  '/patients/$patientId/care-plans/$carePlanId/edit': typeof PatientsPatientIdCarePlansCarePlanIdEditRoute
  '/patients/$patientId/assessments/': typeof PatientsPatientIdLayoutAssessmentsIndexRoute
  '/patients/$patientId/care-plans/': typeof PatientsPatientIdLayoutCarePlansIndexRoute
  '/patients/$patientId/cases/': typeof PatientsPatientIdLayoutCasesIndexRoute
  '/patients/$patientId/documents/': typeof PatientsPatientIdLayoutDocumentsIndexRoute
  '/patients/$patientId/notes/': typeof PatientsPatientIdLayoutNotesIndexRoute
  '/patients/$patientId/profile/': typeof PatientsPatientIdLayoutProfileIndexRoute
  '/patients/$patientId/reports/': typeof PatientsPatientIdLayoutReportsIndexRoute
  '/patients/$patientId/visits/': typeof PatientsPatientIdLayoutVisitsIndexRoute
  '/patients/$patientId/assessments/e/$examId': typeof PatientsPatientIdLayoutAssessmentsEExamIdRoute
  '/patients/$patientId/assessments/m/$measureId': typeof PatientsPatientIdLayoutAssessmentsMMeasureIdRoute
  '/patients/$patientId/assessments/q/$instanceId': typeof PatientsPatientIdLayoutAssessmentsQInstanceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/patients/$patientId': typeof PatientsPatientIdLayoutIndexRoute
  '/settings/hotkeys': typeof SettingsHotkeysRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/patients': typeof PatientsIndexRoute
  '/schedule': typeof ScheduleIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/catalog/devices': typeof CatalogLayoutDevicesRoute
  '/catalog/exams': typeof CatalogLayoutExamsRoute
  '/catalog/locations': typeof CatalogLayoutLocationsRoute
  '/catalog/performance-measures': typeof CatalogLayoutPerformanceMeasuresRoute
  '/catalog/procedures': typeof CatalogLayoutProceduresRoute
  '/catalog/questionnaires': typeof CatalogLayoutQuestionnairesRoute
  '/catalog/devices/$deviceId': typeof CatalogDevicesDeviceIdRoute
  '/catalog/devices/new': typeof CatalogDevicesNewRoute
  '/catalog/diagnostics/$diagnosticId': typeof CatalogDiagnosticsDiagnosticIdRoute
  '/catalog/diagnostics/new': typeof CatalogDiagnosticsNewRoute
  '/catalog/exams/$examId': typeof CatalogExamsExamIdRoute
  '/catalog/exams/new': typeof CatalogExamsNewRoute
  '/catalog/findings/$findingId': typeof CatalogFindingsFindingIdRoute
  '/catalog/findings/new': typeof CatalogFindingsNewRoute
  '/catalog/flows/$flowId': typeof CatalogFlowsFlowIdRoute
  '/catalog/flows/new': typeof CatalogFlowsNewRoute
  '/catalog/locations/$locationId': typeof CatalogLocationsLocationIdRoute
  '/catalog/locations/new': typeof CatalogLocationsNewRoute
  '/catalog/performance-measures/$questionnaireId': typeof CatalogPerformanceMeasuresQuestionnaireIdRoute
  '/catalog/performance-measures/new': typeof CatalogPerformanceMeasuresNewRoute
  '/catalog/procedures/$procedureId': typeof CatalogProceduresProcedureIdRoute
  '/catalog/procedures/new': typeof CatalogProceduresNewRoute
  '/catalog/protocols/$protocolId': typeof CatalogProtocolsProtocolIdRoute
  '/catalog/protocols/new': typeof CatalogProtocolsNewRoute
  '/catalog/questionnaires/$questionnaireId': typeof CatalogQuestionnairesQuestionnaireIdRoute
  '/catalog/questionnaires/new': typeof CatalogQuestionnairesNewRoute
  '/catalog/treatments/$treatmentId': typeof CatalogTreatmentsTreatmentIdRoute
  '/catalog/treatments/new': typeof CatalogTreatmentsNewRoute
  '/chat/$threadId': typeof ChatLayoutThreadIdRoute
  '/schedule/manage/$scheduleId': typeof ScheduleManageScheduleIdRoute
  '/schedule/manage/new': typeof ScheduleManageNewRoute
  '/tasks/$taskId/review': typeof TasksTaskIdReviewRoute
  '/catalog': typeof CatalogLayoutIndexRoute
  '/catalog/flows': typeof CatalogFlowsIndexRoute
  '/chat': typeof ChatLayoutIndexRoute
  '/schedule/manage': typeof ScheduleManageIndexRoute
  '/catalog/devices/$deviceId/edit': typeof CatalogDevicesDeviceIdEditRoute
  '/catalog/diagnostics/$diagnosticId/edit': typeof CatalogDiagnosticsDiagnosticIdEditRoute
  '/catalog/exams/$examId/edit': typeof CatalogExamsExamIdEditRoute
  '/catalog/findings/$findingId/edit': typeof CatalogFindingsFindingIdEditRoute
  '/catalog/locations/$locationId/edit': typeof CatalogLocationsLocationIdEditRoute
  '/catalog/performance-measures/$questionnaireId/edit': typeof CatalogPerformanceMeasuresQuestionnaireIdEditRoute
  '/catalog/procedures/$procedureId/edit': typeof CatalogProceduresProcedureIdEditRoute
  '/catalog/protocols/$protocolId/edit': typeof CatalogProtocolsProtocolIdEditRoute
  '/catalog/questionnaires/$questionnaireId/edit': typeof CatalogQuestionnairesQuestionnaireIdEditRoute
  '/catalog/treatments/$treatmentId/edit': typeof CatalogTreatmentsTreatmentIdEditRoute
  '/patients/$patientId/workbench': typeof PatientsPatientIdLayoutWorkbenchRoute
  '/patients/$patientId/documents/$documentId': typeof PatientsPatientIdDocumentsDocumentIdRoute
  '/patients/$patientId/care-plans/$carePlanId': typeof PatientsPatientIdLayoutCarePlansCarePlanIdRoute
  '/patients/$patientId/cases/$caseId': typeof PatientsPatientIdLayoutCasesCaseIdRoute
  '/patients/$patientId/questionnaire-responses/$qrId': typeof PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute
  '/patients/$patientId/reports/$reportId': typeof PatientsPatientIdLayoutReportsReportIdRoute
  '/patients/$patientId/visits/$visitId': typeof PatientsPatientIdLayoutVisitsVisitIdRoute
  '/patients/$patientId/care-plans/$carePlanId/edit': typeof PatientsPatientIdCarePlansCarePlanIdEditRoute
  '/patients/$patientId/assessments': typeof PatientsPatientIdLayoutAssessmentsIndexRoute
  '/patients/$patientId/care-plans': typeof PatientsPatientIdLayoutCarePlansIndexRoute
  '/patients/$patientId/cases': typeof PatientsPatientIdLayoutCasesIndexRoute
  '/patients/$patientId/documents': typeof PatientsPatientIdLayoutDocumentsIndexRoute
  '/patients/$patientId/notes': typeof PatientsPatientIdLayoutNotesIndexRoute
  '/patients/$patientId/profile': typeof PatientsPatientIdLayoutProfileIndexRoute
  '/patients/$patientId/reports': typeof PatientsPatientIdLayoutReportsIndexRoute
  '/patients/$patientId/visits': typeof PatientsPatientIdLayoutVisitsIndexRoute
  '/patients/$patientId/assessments/e/$examId': typeof PatientsPatientIdLayoutAssessmentsEExamIdRoute
  '/patients/$patientId/assessments/m/$measureId': typeof PatientsPatientIdLayoutAssessmentsMMeasureIdRoute
  '/patients/$patientId/assessments/q/$instanceId': typeof PatientsPatientIdLayoutAssessmentsQInstanceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/catalog/_layout': typeof CatalogLayoutRouteRouteWithChildren
  '/chat/_layout': typeof ChatLayoutRouteRouteWithChildren
  '/patients/$patientId': typeof PatientsPatientIdRouteWithChildren
  '/settings/hotkeys': typeof SettingsHotkeysRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/patients/': typeof PatientsIndexRoute
  '/schedule/': typeof ScheduleIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/patients/$patientId/_layout': typeof PatientsPatientIdLayoutRouteRouteWithChildren
  '/catalog/_layout/devices': typeof CatalogLayoutDevicesRoute
  '/catalog/_layout/exams': typeof CatalogLayoutExamsRoute
  '/catalog/_layout/locations': typeof CatalogLayoutLocationsRoute
  '/catalog/_layout/performance-measures': typeof CatalogLayoutPerformanceMeasuresRoute
  '/catalog/_layout/procedures': typeof CatalogLayoutProceduresRoute
  '/catalog/_layout/questionnaires': typeof CatalogLayoutQuestionnairesRoute
  '/catalog/devices/$deviceId': typeof CatalogDevicesDeviceIdRoute
  '/catalog/devices/new': typeof CatalogDevicesNewRoute
  '/catalog/diagnostics/$diagnosticId': typeof CatalogDiagnosticsDiagnosticIdRoute
  '/catalog/diagnostics/new': typeof CatalogDiagnosticsNewRoute
  '/catalog/exams/$examId': typeof CatalogExamsExamIdRoute
  '/catalog/exams/new': typeof CatalogExamsNewRoute
  '/catalog/findings/$findingId': typeof CatalogFindingsFindingIdRoute
  '/catalog/findings/new': typeof CatalogFindingsNewRoute
  '/catalog/flows/$flowId': typeof CatalogFlowsFlowIdRoute
  '/catalog/flows/new': typeof CatalogFlowsNewRoute
  '/catalog/locations/$locationId': typeof CatalogLocationsLocationIdRoute
  '/catalog/locations/new': typeof CatalogLocationsNewRoute
  '/catalog/performance-measures/$questionnaireId': typeof CatalogPerformanceMeasuresQuestionnaireIdRoute
  '/catalog/performance-measures/new': typeof CatalogPerformanceMeasuresNewRoute
  '/catalog/procedures/$procedureId': typeof CatalogProceduresProcedureIdRoute
  '/catalog/procedures/new': typeof CatalogProceduresNewRoute
  '/catalog/protocols/$protocolId': typeof CatalogProtocolsProtocolIdRoute
  '/catalog/protocols/new': typeof CatalogProtocolsNewRoute
  '/catalog/questionnaires/$questionnaireId': typeof CatalogQuestionnairesQuestionnaireIdRoute
  '/catalog/questionnaires/new': typeof CatalogQuestionnairesNewRoute
  '/catalog/treatments/$treatmentId': typeof CatalogTreatmentsTreatmentIdRoute
  '/catalog/treatments/new': typeof CatalogTreatmentsNewRoute
  '/chat/_layout/$threadId': typeof ChatLayoutThreadIdRoute
  '/schedule/manage/$scheduleId': typeof ScheduleManageScheduleIdRoute
  '/schedule/manage/new': typeof ScheduleManageNewRoute
  '/tasks/$taskId_/review': typeof TasksTaskIdReviewRoute
  '/catalog/_layout/': typeof CatalogLayoutIndexRoute
  '/catalog/flows/': typeof CatalogFlowsIndexRoute
  '/chat/_layout/': typeof ChatLayoutIndexRoute
  '/schedule/manage/': typeof ScheduleManageIndexRoute
  '/patients/$patientId/_layout/assessments': typeof PatientsPatientIdLayoutAssessmentsRouteRouteWithChildren
  '/catalog/devices/$deviceId_/edit': typeof CatalogDevicesDeviceIdEditRoute
  '/catalog/diagnostics/$diagnosticId_/edit': typeof CatalogDiagnosticsDiagnosticIdEditRoute
  '/catalog/exams/$examId_/edit': typeof CatalogExamsExamIdEditRoute
  '/catalog/findings/$findingId_/edit': typeof CatalogFindingsFindingIdEditRoute
  '/catalog/locations/$locationId_/edit': typeof CatalogLocationsLocationIdEditRoute
  '/catalog/performance-measures/$questionnaireId_/edit': typeof CatalogPerformanceMeasuresQuestionnaireIdEditRoute
  '/catalog/procedures/$procedureId_/edit': typeof CatalogProceduresProcedureIdEditRoute
  '/catalog/protocols/$protocolId_/edit': typeof CatalogProtocolsProtocolIdEditRoute
  '/catalog/questionnaires/$questionnaireId_/edit': typeof CatalogQuestionnairesQuestionnaireIdEditRoute
  '/catalog/treatments/$treatmentId_/edit': typeof CatalogTreatmentsTreatmentIdEditRoute
  '/patients/$patientId/_layout/workbench': typeof PatientsPatientIdLayoutWorkbenchRoute
  '/patients/$patientId/documents/$documentId': typeof PatientsPatientIdDocumentsDocumentIdRoute
  '/patients/$patientId/_layout/': typeof PatientsPatientIdLayoutIndexRoute
  '/patients/$patientId/_layout/care-plans/$carePlanId': typeof PatientsPatientIdLayoutCarePlansCarePlanIdRoute
  '/patients/$patientId/_layout/cases/$caseId': typeof PatientsPatientIdLayoutCasesCaseIdRoute
  '/patients/$patientId/_layout/questionnaire-responses/$qrId': typeof PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute
  '/patients/$patientId/_layout/reports/$reportId': typeof PatientsPatientIdLayoutReportsReportIdRoute
  '/patients/$patientId/_layout/visits/$visitId': typeof PatientsPatientIdLayoutVisitsVisitIdRoute
  '/patients/$patientId/care-plans/$carePlanId/edit': typeof PatientsPatientIdCarePlansCarePlanIdEditRoute
  '/patients/$patientId/_layout/assessments/': typeof PatientsPatientIdLayoutAssessmentsIndexRoute
  '/patients/$patientId/_layout/care-plans/': typeof PatientsPatientIdLayoutCarePlansIndexRoute
  '/patients/$patientId/_layout/cases/': typeof PatientsPatientIdLayoutCasesIndexRoute
  '/patients/$patientId/_layout/documents/': typeof PatientsPatientIdLayoutDocumentsIndexRoute
  '/patients/$patientId/_layout/notes/': typeof PatientsPatientIdLayoutNotesIndexRoute
  '/patients/$patientId/_layout/profile/': typeof PatientsPatientIdLayoutProfileIndexRoute
  '/patients/$patientId/_layout/reports/': typeof PatientsPatientIdLayoutReportsIndexRoute
  '/patients/$patientId/_layout/visits/': typeof PatientsPatientIdLayoutVisitsIndexRoute
  '/patients/$patientId/_layout/assessments/e/$examId': typeof PatientsPatientIdLayoutAssessmentsEExamIdRoute
  '/patients/$patientId/_layout/assessments/m/$measureId': typeof PatientsPatientIdLayoutAssessmentsMMeasureIdRoute
  '/patients/$patientId/_layout/assessments/q/$instanceId': typeof PatientsPatientIdLayoutAssessmentsQInstanceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/inbox'
    | '/login'
    | '/catalog'
    | '/chat'
    | '/patients/$patientId'
    | '/settings/hotkeys'
    | '/settings/notifications'
    | '/tasks/$taskId'
    | '/admin/'
    | '/dashboard/'
    | '/patients/'
    | '/schedule/'
    | '/settings/'
    | '/tasks/'
    | '/catalog/devices'
    | '/catalog/exams'
    | '/catalog/locations'
    | '/catalog/performance-measures'
    | '/catalog/procedures'
    | '/catalog/questionnaires'
    | '/catalog/devices/$deviceId'
    | '/catalog/devices/new'
    | '/catalog/diagnostics/$diagnosticId'
    | '/catalog/diagnostics/new'
    | '/catalog/exams/$examId'
    | '/catalog/exams/new'
    | '/catalog/findings/$findingId'
    | '/catalog/findings/new'
    | '/catalog/flows/$flowId'
    | '/catalog/flows/new'
    | '/catalog/locations/$locationId'
    | '/catalog/locations/new'
    | '/catalog/performance-measures/$questionnaireId'
    | '/catalog/performance-measures/new'
    | '/catalog/procedures/$procedureId'
    | '/catalog/procedures/new'
    | '/catalog/protocols/$protocolId'
    | '/catalog/protocols/new'
    | '/catalog/questionnaires/$questionnaireId'
    | '/catalog/questionnaires/new'
    | '/catalog/treatments/$treatmentId'
    | '/catalog/treatments/new'
    | '/chat/$threadId'
    | '/schedule/manage/$scheduleId'
    | '/schedule/manage/new'
    | '/tasks/$taskId/review'
    | '/catalog/'
    | '/catalog/flows/'
    | '/chat/'
    | '/schedule/manage/'
    | '/patients/$patientId/assessments'
    | '/catalog/devices/$deviceId/edit'
    | '/catalog/diagnostics/$diagnosticId/edit'
    | '/catalog/exams/$examId/edit'
    | '/catalog/findings/$findingId/edit'
    | '/catalog/locations/$locationId/edit'
    | '/catalog/performance-measures/$questionnaireId/edit'
    | '/catalog/procedures/$procedureId/edit'
    | '/catalog/protocols/$protocolId/edit'
    | '/catalog/questionnaires/$questionnaireId/edit'
    | '/catalog/treatments/$treatmentId/edit'
    | '/patients/$patientId/workbench'
    | '/patients/$patientId/documents/$documentId'
    | '/patients/$patientId/'
    | '/patients/$patientId/care-plans/$carePlanId'
    | '/patients/$patientId/cases/$caseId'
    | '/patients/$patientId/questionnaire-responses/$qrId'
    | '/patients/$patientId/reports/$reportId'
    | '/patients/$patientId/visits/$visitId'
    | '/patients/$patientId/care-plans/$carePlanId/edit'
    | '/patients/$patientId/assessments/'
    | '/patients/$patientId/care-plans/'
    | '/patients/$patientId/cases/'
    | '/patients/$patientId/documents/'
    | '/patients/$patientId/notes/'
    | '/patients/$patientId/profile/'
    | '/patients/$patientId/reports/'
    | '/patients/$patientId/visits/'
    | '/patients/$patientId/assessments/e/$examId'
    | '/patients/$patientId/assessments/m/$measureId'
    | '/patients/$patientId/assessments/q/$instanceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/inbox'
    | '/login'
    | '/patients/$patientId'
    | '/settings/hotkeys'
    | '/settings/notifications'
    | '/tasks/$taskId'
    | '/admin'
    | '/dashboard'
    | '/patients'
    | '/schedule'
    | '/settings'
    | '/tasks'
    | '/catalog/devices'
    | '/catalog/exams'
    | '/catalog/locations'
    | '/catalog/performance-measures'
    | '/catalog/procedures'
    | '/catalog/questionnaires'
    | '/catalog/devices/$deviceId'
    | '/catalog/devices/new'
    | '/catalog/diagnostics/$diagnosticId'
    | '/catalog/diagnostics/new'
    | '/catalog/exams/$examId'
    | '/catalog/exams/new'
    | '/catalog/findings/$findingId'
    | '/catalog/findings/new'
    | '/catalog/flows/$flowId'
    | '/catalog/flows/new'
    | '/catalog/locations/$locationId'
    | '/catalog/locations/new'
    | '/catalog/performance-measures/$questionnaireId'
    | '/catalog/performance-measures/new'
    | '/catalog/procedures/$procedureId'
    | '/catalog/procedures/new'
    | '/catalog/protocols/$protocolId'
    | '/catalog/protocols/new'
    | '/catalog/questionnaires/$questionnaireId'
    | '/catalog/questionnaires/new'
    | '/catalog/treatments/$treatmentId'
    | '/catalog/treatments/new'
    | '/chat/$threadId'
    | '/schedule/manage/$scheduleId'
    | '/schedule/manage/new'
    | '/tasks/$taskId/review'
    | '/catalog'
    | '/catalog/flows'
    | '/chat'
    | '/schedule/manage'
    | '/catalog/devices/$deviceId/edit'
    | '/catalog/diagnostics/$diagnosticId/edit'
    | '/catalog/exams/$examId/edit'
    | '/catalog/findings/$findingId/edit'
    | '/catalog/locations/$locationId/edit'
    | '/catalog/performance-measures/$questionnaireId/edit'
    | '/catalog/procedures/$procedureId/edit'
    | '/catalog/protocols/$protocolId/edit'
    | '/catalog/questionnaires/$questionnaireId/edit'
    | '/catalog/treatments/$treatmentId/edit'
    | '/patients/$patientId/workbench'
    | '/patients/$patientId/documents/$documentId'
    | '/patients/$patientId/care-plans/$carePlanId'
    | '/patients/$patientId/cases/$caseId'
    | '/patients/$patientId/questionnaire-responses/$qrId'
    | '/patients/$patientId/reports/$reportId'
    | '/patients/$patientId/visits/$visitId'
    | '/patients/$patientId/care-plans/$carePlanId/edit'
    | '/patients/$patientId/assessments'
    | '/patients/$patientId/care-plans'
    | '/patients/$patientId/cases'
    | '/patients/$patientId/documents'
    | '/patients/$patientId/notes'
    | '/patients/$patientId/profile'
    | '/patients/$patientId/reports'
    | '/patients/$patientId/visits'
    | '/patients/$patientId/assessments/e/$examId'
    | '/patients/$patientId/assessments/m/$measureId'
    | '/patients/$patientId/assessments/q/$instanceId'
  id:
    | '__root__'
    | '/'
    | '/inbox'
    | '/login'
    | '/catalog/_layout'
    | '/chat/_layout'
    | '/patients/$patientId'
    | '/settings/hotkeys'
    | '/settings/notifications'
    | '/tasks/$taskId'
    | '/admin/'
    | '/dashboard/'
    | '/patients/'
    | '/schedule/'
    | '/settings/'
    | '/tasks/'
    | '/patients/$patientId/_layout'
    | '/catalog/_layout/devices'
    | '/catalog/_layout/exams'
    | '/catalog/_layout/locations'
    | '/catalog/_layout/performance-measures'
    | '/catalog/_layout/procedures'
    | '/catalog/_layout/questionnaires'
    | '/catalog/devices/$deviceId'
    | '/catalog/devices/new'
    | '/catalog/diagnostics/$diagnosticId'
    | '/catalog/diagnostics/new'
    | '/catalog/exams/$examId'
    | '/catalog/exams/new'
    | '/catalog/findings/$findingId'
    | '/catalog/findings/new'
    | '/catalog/flows/$flowId'
    | '/catalog/flows/new'
    | '/catalog/locations/$locationId'
    | '/catalog/locations/new'
    | '/catalog/performance-measures/$questionnaireId'
    | '/catalog/performance-measures/new'
    | '/catalog/procedures/$procedureId'
    | '/catalog/procedures/new'
    | '/catalog/protocols/$protocolId'
    | '/catalog/protocols/new'
    | '/catalog/questionnaires/$questionnaireId'
    | '/catalog/questionnaires/new'
    | '/catalog/treatments/$treatmentId'
    | '/catalog/treatments/new'
    | '/chat/_layout/$threadId'
    | '/schedule/manage/$scheduleId'
    | '/schedule/manage/new'
    | '/tasks/$taskId_/review'
    | '/catalog/_layout/'
    | '/catalog/flows/'
    | '/chat/_layout/'
    | '/schedule/manage/'
    | '/patients/$patientId/_layout/assessments'
    | '/catalog/devices/$deviceId_/edit'
    | '/catalog/diagnostics/$diagnosticId_/edit'
    | '/catalog/exams/$examId_/edit'
    | '/catalog/findings/$findingId_/edit'
    | '/catalog/locations/$locationId_/edit'
    | '/catalog/performance-measures/$questionnaireId_/edit'
    | '/catalog/procedures/$procedureId_/edit'
    | '/catalog/protocols/$protocolId_/edit'
    | '/catalog/questionnaires/$questionnaireId_/edit'
    | '/catalog/treatments/$treatmentId_/edit'
    | '/patients/$patientId/_layout/workbench'
    | '/patients/$patientId/documents/$documentId'
    | '/patients/$patientId/_layout/'
    | '/patients/$patientId/_layout/care-plans/$carePlanId'
    | '/patients/$patientId/_layout/cases/$caseId'
    | '/patients/$patientId/_layout/questionnaire-responses/$qrId'
    | '/patients/$patientId/_layout/reports/$reportId'
    | '/patients/$patientId/_layout/visits/$visitId'
    | '/patients/$patientId/care-plans/$carePlanId/edit'
    | '/patients/$patientId/_layout/assessments/'
    | '/patients/$patientId/_layout/care-plans/'
    | '/patients/$patientId/_layout/cases/'
    | '/patients/$patientId/_layout/documents/'
    | '/patients/$patientId/_layout/notes/'
    | '/patients/$patientId/_layout/profile/'
    | '/patients/$patientId/_layout/reports/'
    | '/patients/$patientId/_layout/visits/'
    | '/patients/$patientId/_layout/assessments/e/$examId'
    | '/patients/$patientId/_layout/assessments/m/$measureId'
    | '/patients/$patientId/_layout/assessments/q/$instanceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  CatalogLayoutRouteRoute: typeof CatalogLayoutRouteRouteWithChildren
  ChatLayoutRouteRoute: typeof ChatLayoutRouteRouteWithChildren
  PatientsPatientIdRoute: typeof PatientsPatientIdRouteWithChildren
  SettingsHotkeysRoute: typeof SettingsHotkeysRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  PatientsIndexRoute: typeof PatientsIndexRoute
  ScheduleIndexRoute: typeof ScheduleIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  CatalogDevicesDeviceIdRoute: typeof CatalogDevicesDeviceIdRoute
  CatalogDevicesNewRoute: typeof CatalogDevicesNewRoute
  CatalogDiagnosticsDiagnosticIdRoute: typeof CatalogDiagnosticsDiagnosticIdRoute
  CatalogDiagnosticsNewRoute: typeof CatalogDiagnosticsNewRoute
  CatalogExamsExamIdRoute: typeof CatalogExamsExamIdRoute
  CatalogExamsNewRoute: typeof CatalogExamsNewRoute
  CatalogFindingsFindingIdRoute: typeof CatalogFindingsFindingIdRoute
  CatalogFindingsNewRoute: typeof CatalogFindingsNewRoute
  CatalogFlowsFlowIdRoute: typeof CatalogFlowsFlowIdRoute
  CatalogFlowsNewRoute: typeof CatalogFlowsNewRoute
  CatalogLocationsLocationIdRoute: typeof CatalogLocationsLocationIdRoute
  CatalogLocationsNewRoute: typeof CatalogLocationsNewRoute
  CatalogPerformanceMeasuresQuestionnaireIdRoute: typeof CatalogPerformanceMeasuresQuestionnaireIdRoute
  CatalogPerformanceMeasuresNewRoute: typeof CatalogPerformanceMeasuresNewRoute
  CatalogProceduresProcedureIdRoute: typeof CatalogProceduresProcedureIdRoute
  CatalogProceduresNewRoute: typeof CatalogProceduresNewRoute
  CatalogProtocolsProtocolIdRoute: typeof CatalogProtocolsProtocolIdRoute
  CatalogProtocolsNewRoute: typeof CatalogProtocolsNewRoute
  CatalogQuestionnairesQuestionnaireIdRoute: typeof CatalogQuestionnairesQuestionnaireIdRoute
  CatalogQuestionnairesNewRoute: typeof CatalogQuestionnairesNewRoute
  CatalogTreatmentsTreatmentIdRoute: typeof CatalogTreatmentsTreatmentIdRoute
  CatalogTreatmentsNewRoute: typeof CatalogTreatmentsNewRoute
  ScheduleManageScheduleIdRoute: typeof ScheduleManageScheduleIdRoute
  ScheduleManageNewRoute: typeof ScheduleManageNewRoute
  TasksTaskIdReviewRoute: typeof TasksTaskIdReviewRoute
  CatalogFlowsIndexRoute: typeof CatalogFlowsIndexRoute
  ScheduleManageIndexRoute: typeof ScheduleManageIndexRoute
  CatalogDevicesDeviceIdEditRoute: typeof CatalogDevicesDeviceIdEditRoute
  CatalogDiagnosticsDiagnosticIdEditRoute: typeof CatalogDiagnosticsDiagnosticIdEditRoute
  CatalogExamsExamIdEditRoute: typeof CatalogExamsExamIdEditRoute
  CatalogFindingsFindingIdEditRoute: typeof CatalogFindingsFindingIdEditRoute
  CatalogLocationsLocationIdEditRoute: typeof CatalogLocationsLocationIdEditRoute
  CatalogPerformanceMeasuresQuestionnaireIdEditRoute: typeof CatalogPerformanceMeasuresQuestionnaireIdEditRoute
  CatalogProceduresProcedureIdEditRoute: typeof CatalogProceduresProcedureIdEditRoute
  CatalogProtocolsProtocolIdEditRoute: typeof CatalogProtocolsProtocolIdEditRoute
  CatalogQuestionnairesQuestionnaireIdEditRoute: typeof CatalogQuestionnairesQuestionnaireIdEditRoute
  CatalogTreatmentsTreatmentIdEditRoute: typeof CatalogTreatmentsTreatmentIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/': {
      id: '/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof ScheduleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/': {
      id: '/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof PatientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/hotkeys': {
      id: '/settings/hotkeys'
      path: '/settings/hotkeys'
      fullPath: '/settings/hotkeys'
      preLoaderRoute: typeof SettingsHotkeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/$patientId': {
      id: '/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof PatientsPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/_layout': {
      id: '/chat/_layout'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/_layout': {
      id: '/catalog/_layout'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/manage/': {
      id: '/schedule/manage/'
      path: '/schedule/manage'
      fullPath: '/schedule/manage/'
      preLoaderRoute: typeof ScheduleManageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/_layout/': {
      id: '/chat/_layout/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatLayoutIndexRouteImport
      parentRoute: typeof ChatLayoutRouteRoute
    }
    '/catalog/flows/': {
      id: '/catalog/flows/'
      path: '/catalog/flows'
      fullPath: '/catalog/flows/'
      preLoaderRoute: typeof CatalogFlowsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/_layout/': {
      id: '/catalog/_layout/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogLayoutIndexRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/tasks/$taskId_/review': {
      id: '/tasks/$taskId_/review'
      path: '/tasks/$taskId/review'
      fullPath: '/tasks/$taskId/review'
      preLoaderRoute: typeof TasksTaskIdReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/manage/new': {
      id: '/schedule/manage/new'
      path: '/schedule/manage/new'
      fullPath: '/schedule/manage/new'
      preLoaderRoute: typeof ScheduleManageNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/manage/$scheduleId': {
      id: '/schedule/manage/$scheduleId'
      path: '/schedule/manage/$scheduleId'
      fullPath: '/schedule/manage/$scheduleId'
      preLoaderRoute: typeof ScheduleManageScheduleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/_layout/$threadId': {
      id: '/chat/_layout/$threadId'
      path: '/$threadId'
      fullPath: '/chat/$threadId'
      preLoaderRoute: typeof ChatLayoutThreadIdRouteImport
      parentRoute: typeof ChatLayoutRouteRoute
    }
    '/catalog/treatments/new': {
      id: '/catalog/treatments/new'
      path: '/catalog/treatments/new'
      fullPath: '/catalog/treatments/new'
      preLoaderRoute: typeof CatalogTreatmentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/treatments/$treatmentId': {
      id: '/catalog/treatments/$treatmentId'
      path: '/catalog/treatments/$treatmentId'
      fullPath: '/catalog/treatments/$treatmentId'
      preLoaderRoute: typeof CatalogTreatmentsTreatmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/questionnaires/new': {
      id: '/catalog/questionnaires/new'
      path: '/catalog/questionnaires/new'
      fullPath: '/catalog/questionnaires/new'
      preLoaderRoute: typeof CatalogQuestionnairesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/questionnaires/$questionnaireId': {
      id: '/catalog/questionnaires/$questionnaireId'
      path: '/catalog/questionnaires/$questionnaireId'
      fullPath: '/catalog/questionnaires/$questionnaireId'
      preLoaderRoute: typeof CatalogQuestionnairesQuestionnaireIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/protocols/new': {
      id: '/catalog/protocols/new'
      path: '/catalog/protocols/new'
      fullPath: '/catalog/protocols/new'
      preLoaderRoute: typeof CatalogProtocolsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/protocols/$protocolId': {
      id: '/catalog/protocols/$protocolId'
      path: '/catalog/protocols/$protocolId'
      fullPath: '/catalog/protocols/$protocolId'
      preLoaderRoute: typeof CatalogProtocolsProtocolIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/procedures/new': {
      id: '/catalog/procedures/new'
      path: '/catalog/procedures/new'
      fullPath: '/catalog/procedures/new'
      preLoaderRoute: typeof CatalogProceduresNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/procedures/$procedureId': {
      id: '/catalog/procedures/$procedureId'
      path: '/catalog/procedures/$procedureId'
      fullPath: '/catalog/procedures/$procedureId'
      preLoaderRoute: typeof CatalogProceduresProcedureIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/performance-measures/new': {
      id: '/catalog/performance-measures/new'
      path: '/catalog/performance-measures/new'
      fullPath: '/catalog/performance-measures/new'
      preLoaderRoute: typeof CatalogPerformanceMeasuresNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/performance-measures/$questionnaireId': {
      id: '/catalog/performance-measures/$questionnaireId'
      path: '/catalog/performance-measures/$questionnaireId'
      fullPath: '/catalog/performance-measures/$questionnaireId'
      preLoaderRoute: typeof CatalogPerformanceMeasuresQuestionnaireIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/locations/new': {
      id: '/catalog/locations/new'
      path: '/catalog/locations/new'
      fullPath: '/catalog/locations/new'
      preLoaderRoute: typeof CatalogLocationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/locations/$locationId': {
      id: '/catalog/locations/$locationId'
      path: '/catalog/locations/$locationId'
      fullPath: '/catalog/locations/$locationId'
      preLoaderRoute: typeof CatalogLocationsLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/flows/new': {
      id: '/catalog/flows/new'
      path: '/catalog/flows/new'
      fullPath: '/catalog/flows/new'
      preLoaderRoute: typeof CatalogFlowsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/flows/$flowId': {
      id: '/catalog/flows/$flowId'
      path: '/catalog/flows/$flowId'
      fullPath: '/catalog/flows/$flowId'
      preLoaderRoute: typeof CatalogFlowsFlowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/findings/new': {
      id: '/catalog/findings/new'
      path: '/catalog/findings/new'
      fullPath: '/catalog/findings/new'
      preLoaderRoute: typeof CatalogFindingsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/findings/$findingId': {
      id: '/catalog/findings/$findingId'
      path: '/catalog/findings/$findingId'
      fullPath: '/catalog/findings/$findingId'
      preLoaderRoute: typeof CatalogFindingsFindingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/exams/new': {
      id: '/catalog/exams/new'
      path: '/catalog/exams/new'
      fullPath: '/catalog/exams/new'
      preLoaderRoute: typeof CatalogExamsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/exams/$examId': {
      id: '/catalog/exams/$examId'
      path: '/catalog/exams/$examId'
      fullPath: '/catalog/exams/$examId'
      preLoaderRoute: typeof CatalogExamsExamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/diagnostics/new': {
      id: '/catalog/diagnostics/new'
      path: '/catalog/diagnostics/new'
      fullPath: '/catalog/diagnostics/new'
      preLoaderRoute: typeof CatalogDiagnosticsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/diagnostics/$diagnosticId': {
      id: '/catalog/diagnostics/$diagnosticId'
      path: '/catalog/diagnostics/$diagnosticId'
      fullPath: '/catalog/diagnostics/$diagnosticId'
      preLoaderRoute: typeof CatalogDiagnosticsDiagnosticIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/devices/new': {
      id: '/catalog/devices/new'
      path: '/catalog/devices/new'
      fullPath: '/catalog/devices/new'
      preLoaderRoute: typeof CatalogDevicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/devices/$deviceId': {
      id: '/catalog/devices/$deviceId'
      path: '/catalog/devices/$deviceId'
      fullPath: '/catalog/devices/$deviceId'
      preLoaderRoute: typeof CatalogDevicesDeviceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/_layout/questionnaires': {
      id: '/catalog/_layout/questionnaires'
      path: '/questionnaires'
      fullPath: '/catalog/questionnaires'
      preLoaderRoute: typeof CatalogLayoutQuestionnairesRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/catalog/_layout/procedures': {
      id: '/catalog/_layout/procedures'
      path: '/procedures'
      fullPath: '/catalog/procedures'
      preLoaderRoute: typeof CatalogLayoutProceduresRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/catalog/_layout/performance-measures': {
      id: '/catalog/_layout/performance-measures'
      path: '/performance-measures'
      fullPath: '/catalog/performance-measures'
      preLoaderRoute: typeof CatalogLayoutPerformanceMeasuresRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/catalog/_layout/locations': {
      id: '/catalog/_layout/locations'
      path: '/locations'
      fullPath: '/catalog/locations'
      preLoaderRoute: typeof CatalogLayoutLocationsRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/catalog/_layout/exams': {
      id: '/catalog/_layout/exams'
      path: '/exams'
      fullPath: '/catalog/exams'
      preLoaderRoute: typeof CatalogLayoutExamsRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/catalog/_layout/devices': {
      id: '/catalog/_layout/devices'
      path: '/devices'
      fullPath: '/catalog/devices'
      preLoaderRoute: typeof CatalogLayoutDevicesRouteImport
      parentRoute: typeof CatalogLayoutRouteRoute
    }
    '/patients/$patientId/_layout': {
      id: '/patients/$patientId/_layout'
      path: ''
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof PatientsPatientIdLayoutRouteRouteImport
      parentRoute: typeof PatientsPatientIdRoute
    }
    '/patients/$patientId/_layout/': {
      id: '/patients/$patientId/_layout/'
      path: '/'
      fullPath: '/patients/$patientId/'
      preLoaderRoute: typeof PatientsPatientIdLayoutIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/documents/$documentId': {
      id: '/patients/$patientId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/patients/$patientId/documents/$documentId'
      preLoaderRoute: typeof PatientsPatientIdDocumentsDocumentIdRouteImport
      parentRoute: typeof PatientsPatientIdRoute
    }
    '/patients/$patientId/_layout/workbench': {
      id: '/patients/$patientId/_layout/workbench'
      path: '/workbench'
      fullPath: '/patients/$patientId/workbench'
      preLoaderRoute: typeof PatientsPatientIdLayoutWorkbenchRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/catalog/treatments/$treatmentId_/edit': {
      id: '/catalog/treatments/$treatmentId_/edit'
      path: '/catalog/treatments/$treatmentId/edit'
      fullPath: '/catalog/treatments/$treatmentId/edit'
      preLoaderRoute: typeof CatalogTreatmentsTreatmentIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/questionnaires/$questionnaireId_/edit': {
      id: '/catalog/questionnaires/$questionnaireId_/edit'
      path: '/catalog/questionnaires/$questionnaireId/edit'
      fullPath: '/catalog/questionnaires/$questionnaireId/edit'
      preLoaderRoute: typeof CatalogQuestionnairesQuestionnaireIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/protocols/$protocolId_/edit': {
      id: '/catalog/protocols/$protocolId_/edit'
      path: '/catalog/protocols/$protocolId/edit'
      fullPath: '/catalog/protocols/$protocolId/edit'
      preLoaderRoute: typeof CatalogProtocolsProtocolIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/procedures/$procedureId_/edit': {
      id: '/catalog/procedures/$procedureId_/edit'
      path: '/catalog/procedures/$procedureId/edit'
      fullPath: '/catalog/procedures/$procedureId/edit'
      preLoaderRoute: typeof CatalogProceduresProcedureIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/performance-measures/$questionnaireId_/edit': {
      id: '/catalog/performance-measures/$questionnaireId_/edit'
      path: '/catalog/performance-measures/$questionnaireId/edit'
      fullPath: '/catalog/performance-measures/$questionnaireId/edit'
      preLoaderRoute: typeof CatalogPerformanceMeasuresQuestionnaireIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/locations/$locationId_/edit': {
      id: '/catalog/locations/$locationId_/edit'
      path: '/catalog/locations/$locationId/edit'
      fullPath: '/catalog/locations/$locationId/edit'
      preLoaderRoute: typeof CatalogLocationsLocationIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/findings/$findingId_/edit': {
      id: '/catalog/findings/$findingId_/edit'
      path: '/catalog/findings/$findingId/edit'
      fullPath: '/catalog/findings/$findingId/edit'
      preLoaderRoute: typeof CatalogFindingsFindingIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/exams/$examId_/edit': {
      id: '/catalog/exams/$examId_/edit'
      path: '/catalog/exams/$examId/edit'
      fullPath: '/catalog/exams/$examId/edit'
      preLoaderRoute: typeof CatalogExamsExamIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/diagnostics/$diagnosticId_/edit': {
      id: '/catalog/diagnostics/$diagnosticId_/edit'
      path: '/catalog/diagnostics/$diagnosticId/edit'
      fullPath: '/catalog/diagnostics/$diagnosticId/edit'
      preLoaderRoute: typeof CatalogDiagnosticsDiagnosticIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/devices/$deviceId_/edit': {
      id: '/catalog/devices/$deviceId_/edit'
      path: '/catalog/devices/$deviceId/edit'
      fullPath: '/catalog/devices/$deviceId/edit'
      preLoaderRoute: typeof CatalogDevicesDeviceIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/$patientId/_layout/assessments': {
      id: '/patients/$patientId/_layout/assessments'
      path: '/assessments'
      fullPath: '/patients/$patientId/assessments'
      preLoaderRoute: typeof PatientsPatientIdLayoutAssessmentsRouteRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/visits/': {
      id: '/patients/$patientId/_layout/visits/'
      path: '/visits'
      fullPath: '/patients/$patientId/visits/'
      preLoaderRoute: typeof PatientsPatientIdLayoutVisitsIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/reports/': {
      id: '/patients/$patientId/_layout/reports/'
      path: '/reports'
      fullPath: '/patients/$patientId/reports/'
      preLoaderRoute: typeof PatientsPatientIdLayoutReportsIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/profile/': {
      id: '/patients/$patientId/_layout/profile/'
      path: '/profile'
      fullPath: '/patients/$patientId/profile/'
      preLoaderRoute: typeof PatientsPatientIdLayoutProfileIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/notes/': {
      id: '/patients/$patientId/_layout/notes/'
      path: '/notes'
      fullPath: '/patients/$patientId/notes/'
      preLoaderRoute: typeof PatientsPatientIdLayoutNotesIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/documents/': {
      id: '/patients/$patientId/_layout/documents/'
      path: '/documents'
      fullPath: '/patients/$patientId/documents/'
      preLoaderRoute: typeof PatientsPatientIdLayoutDocumentsIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/cases/': {
      id: '/patients/$patientId/_layout/cases/'
      path: '/cases'
      fullPath: '/patients/$patientId/cases/'
      preLoaderRoute: typeof PatientsPatientIdLayoutCasesIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/care-plans/': {
      id: '/patients/$patientId/_layout/care-plans/'
      path: '/care-plans'
      fullPath: '/patients/$patientId/care-plans/'
      preLoaderRoute: typeof PatientsPatientIdLayoutCarePlansIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/assessments/': {
      id: '/patients/$patientId/_layout/assessments/'
      path: '/'
      fullPath: '/patients/$patientId/assessments/'
      preLoaderRoute: typeof PatientsPatientIdLayoutAssessmentsIndexRouteImport
      parentRoute: typeof PatientsPatientIdLayoutAssessmentsRouteRoute
    }
    '/patients/$patientId/care-plans/$carePlanId/edit': {
      id: '/patients/$patientId/care-plans/$carePlanId/edit'
      path: '/care-plans/$carePlanId/edit'
      fullPath: '/patients/$patientId/care-plans/$carePlanId/edit'
      preLoaderRoute: typeof PatientsPatientIdCarePlansCarePlanIdEditRouteImport
      parentRoute: typeof PatientsPatientIdRoute
    }
    '/patients/$patientId/_layout/visits/$visitId': {
      id: '/patients/$patientId/_layout/visits/$visitId'
      path: '/visits/$visitId'
      fullPath: '/patients/$patientId/visits/$visitId'
      preLoaderRoute: typeof PatientsPatientIdLayoutVisitsVisitIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/reports/$reportId': {
      id: '/patients/$patientId/_layout/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/patients/$patientId/reports/$reportId'
      preLoaderRoute: typeof PatientsPatientIdLayoutReportsReportIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/questionnaire-responses/$qrId': {
      id: '/patients/$patientId/_layout/questionnaire-responses/$qrId'
      path: '/questionnaire-responses/$qrId'
      fullPath: '/patients/$patientId/questionnaire-responses/$qrId'
      preLoaderRoute: typeof PatientsPatientIdLayoutQuestionnaireResponsesQrIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/cases/$caseId': {
      id: '/patients/$patientId/_layout/cases/$caseId'
      path: '/cases/$caseId'
      fullPath: '/patients/$patientId/cases/$caseId'
      preLoaderRoute: typeof PatientsPatientIdLayoutCasesCaseIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/care-plans/$carePlanId': {
      id: '/patients/$patientId/_layout/care-plans/$carePlanId'
      path: '/care-plans/$carePlanId'
      fullPath: '/patients/$patientId/care-plans/$carePlanId'
      preLoaderRoute: typeof PatientsPatientIdLayoutCarePlansCarePlanIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutRouteRoute
    }
    '/patients/$patientId/_layout/assessments/q/$instanceId': {
      id: '/patients/$patientId/_layout/assessments/q/$instanceId'
      path: '/q/$instanceId'
      fullPath: '/patients/$patientId/assessments/q/$instanceId'
      preLoaderRoute: typeof PatientsPatientIdLayoutAssessmentsQInstanceIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutAssessmentsRouteRoute
    }
    '/patients/$patientId/_layout/assessments/m/$measureId': {
      id: '/patients/$patientId/_layout/assessments/m/$measureId'
      path: '/m/$measureId'
      fullPath: '/patients/$patientId/assessments/m/$measureId'
      preLoaderRoute: typeof PatientsPatientIdLayoutAssessmentsMMeasureIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutAssessmentsRouteRoute
    }
    '/patients/$patientId/_layout/assessments/e/$examId': {
      id: '/patients/$patientId/_layout/assessments/e/$examId'
      path: '/e/$examId'
      fullPath: '/patients/$patientId/assessments/e/$examId'
      preLoaderRoute: typeof PatientsPatientIdLayoutAssessmentsEExamIdRouteImport
      parentRoute: typeof PatientsPatientIdLayoutAssessmentsRouteRoute
    }
  }
}

interface CatalogLayoutRouteRouteChildren {
  CatalogLayoutDevicesRoute: typeof CatalogLayoutDevicesRoute
  CatalogLayoutExamsRoute: typeof CatalogLayoutExamsRoute
  CatalogLayoutLocationsRoute: typeof CatalogLayoutLocationsRoute
  CatalogLayoutPerformanceMeasuresRoute: typeof CatalogLayoutPerformanceMeasuresRoute
  CatalogLayoutProceduresRoute: typeof CatalogLayoutProceduresRoute
  CatalogLayoutQuestionnairesRoute: typeof CatalogLayoutQuestionnairesRoute
  CatalogLayoutIndexRoute: typeof CatalogLayoutIndexRoute
}

const CatalogLayoutRouteRouteChildren: CatalogLayoutRouteRouteChildren = {
  CatalogLayoutDevicesRoute: CatalogLayoutDevicesRoute,
  CatalogLayoutExamsRoute: CatalogLayoutExamsRoute,
  CatalogLayoutLocationsRoute: CatalogLayoutLocationsRoute,
  CatalogLayoutPerformanceMeasuresRoute: CatalogLayoutPerformanceMeasuresRoute,
  CatalogLayoutProceduresRoute: CatalogLayoutProceduresRoute,
  CatalogLayoutQuestionnairesRoute: CatalogLayoutQuestionnairesRoute,
  CatalogLayoutIndexRoute: CatalogLayoutIndexRoute,
}

const CatalogLayoutRouteRouteWithChildren =
  CatalogLayoutRouteRoute._addFileChildren(CatalogLayoutRouteRouteChildren)

interface ChatLayoutRouteRouteChildren {
  ChatLayoutThreadIdRoute: typeof ChatLayoutThreadIdRoute
  ChatLayoutIndexRoute: typeof ChatLayoutIndexRoute
}

const ChatLayoutRouteRouteChildren: ChatLayoutRouteRouteChildren = {
  ChatLayoutThreadIdRoute: ChatLayoutThreadIdRoute,
  ChatLayoutIndexRoute: ChatLayoutIndexRoute,
}

const ChatLayoutRouteRouteWithChildren = ChatLayoutRouteRoute._addFileChildren(
  ChatLayoutRouteRouteChildren,
)

interface PatientsPatientIdLayoutAssessmentsRouteRouteChildren {
  PatientsPatientIdLayoutAssessmentsIndexRoute: typeof PatientsPatientIdLayoutAssessmentsIndexRoute
  PatientsPatientIdLayoutAssessmentsEExamIdRoute: typeof PatientsPatientIdLayoutAssessmentsEExamIdRoute
  PatientsPatientIdLayoutAssessmentsMMeasureIdRoute: typeof PatientsPatientIdLayoutAssessmentsMMeasureIdRoute
  PatientsPatientIdLayoutAssessmentsQInstanceIdRoute: typeof PatientsPatientIdLayoutAssessmentsQInstanceIdRoute
}

const PatientsPatientIdLayoutAssessmentsRouteRouteChildren: PatientsPatientIdLayoutAssessmentsRouteRouteChildren =
  {
    PatientsPatientIdLayoutAssessmentsIndexRoute:
      PatientsPatientIdLayoutAssessmentsIndexRoute,
    PatientsPatientIdLayoutAssessmentsEExamIdRoute:
      PatientsPatientIdLayoutAssessmentsEExamIdRoute,
    PatientsPatientIdLayoutAssessmentsMMeasureIdRoute:
      PatientsPatientIdLayoutAssessmentsMMeasureIdRoute,
    PatientsPatientIdLayoutAssessmentsQInstanceIdRoute:
      PatientsPatientIdLayoutAssessmentsQInstanceIdRoute,
  }

const PatientsPatientIdLayoutAssessmentsRouteRouteWithChildren =
  PatientsPatientIdLayoutAssessmentsRouteRoute._addFileChildren(
    PatientsPatientIdLayoutAssessmentsRouteRouteChildren,
  )

interface PatientsPatientIdLayoutRouteRouteChildren {
  PatientsPatientIdLayoutAssessmentsRouteRoute: typeof PatientsPatientIdLayoutAssessmentsRouteRouteWithChildren
  PatientsPatientIdLayoutWorkbenchRoute: typeof PatientsPatientIdLayoutWorkbenchRoute
  PatientsPatientIdLayoutIndexRoute: typeof PatientsPatientIdLayoutIndexRoute
  PatientsPatientIdLayoutCarePlansCarePlanIdRoute: typeof PatientsPatientIdLayoutCarePlansCarePlanIdRoute
  PatientsPatientIdLayoutCasesCaseIdRoute: typeof PatientsPatientIdLayoutCasesCaseIdRoute
  PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute: typeof PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute
  PatientsPatientIdLayoutReportsReportIdRoute: typeof PatientsPatientIdLayoutReportsReportIdRoute
  PatientsPatientIdLayoutVisitsVisitIdRoute: typeof PatientsPatientIdLayoutVisitsVisitIdRoute
  PatientsPatientIdLayoutCarePlansIndexRoute: typeof PatientsPatientIdLayoutCarePlansIndexRoute
  PatientsPatientIdLayoutCasesIndexRoute: typeof PatientsPatientIdLayoutCasesIndexRoute
  PatientsPatientIdLayoutDocumentsIndexRoute: typeof PatientsPatientIdLayoutDocumentsIndexRoute
  PatientsPatientIdLayoutNotesIndexRoute: typeof PatientsPatientIdLayoutNotesIndexRoute
  PatientsPatientIdLayoutProfileIndexRoute: typeof PatientsPatientIdLayoutProfileIndexRoute
  PatientsPatientIdLayoutReportsIndexRoute: typeof PatientsPatientIdLayoutReportsIndexRoute
  PatientsPatientIdLayoutVisitsIndexRoute: typeof PatientsPatientIdLayoutVisitsIndexRoute
}

const PatientsPatientIdLayoutRouteRouteChildren: PatientsPatientIdLayoutRouteRouteChildren =
  {
    PatientsPatientIdLayoutAssessmentsRouteRoute:
      PatientsPatientIdLayoutAssessmentsRouteRouteWithChildren,
    PatientsPatientIdLayoutWorkbenchRoute:
      PatientsPatientIdLayoutWorkbenchRoute,
    PatientsPatientIdLayoutIndexRoute: PatientsPatientIdLayoutIndexRoute,
    PatientsPatientIdLayoutCarePlansCarePlanIdRoute:
      PatientsPatientIdLayoutCarePlansCarePlanIdRoute,
    PatientsPatientIdLayoutCasesCaseIdRoute:
      PatientsPatientIdLayoutCasesCaseIdRoute,
    PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute:
      PatientsPatientIdLayoutQuestionnaireResponsesQrIdRoute,
    PatientsPatientIdLayoutReportsReportIdRoute:
      PatientsPatientIdLayoutReportsReportIdRoute,
    PatientsPatientIdLayoutVisitsVisitIdRoute:
      PatientsPatientIdLayoutVisitsVisitIdRoute,
    PatientsPatientIdLayoutCarePlansIndexRoute:
      PatientsPatientIdLayoutCarePlansIndexRoute,
    PatientsPatientIdLayoutCasesIndexRoute:
      PatientsPatientIdLayoutCasesIndexRoute,
    PatientsPatientIdLayoutDocumentsIndexRoute:
      PatientsPatientIdLayoutDocumentsIndexRoute,
    PatientsPatientIdLayoutNotesIndexRoute:
      PatientsPatientIdLayoutNotesIndexRoute,
    PatientsPatientIdLayoutProfileIndexRoute:
      PatientsPatientIdLayoutProfileIndexRoute,
    PatientsPatientIdLayoutReportsIndexRoute:
      PatientsPatientIdLayoutReportsIndexRoute,
    PatientsPatientIdLayoutVisitsIndexRoute:
      PatientsPatientIdLayoutVisitsIndexRoute,
  }

const PatientsPatientIdLayoutRouteRouteWithChildren =
  PatientsPatientIdLayoutRouteRoute._addFileChildren(
    PatientsPatientIdLayoutRouteRouteChildren,
  )

interface PatientsPatientIdRouteChildren {
  PatientsPatientIdLayoutRouteRoute: typeof PatientsPatientIdLayoutRouteRouteWithChildren
  PatientsPatientIdDocumentsDocumentIdRoute: typeof PatientsPatientIdDocumentsDocumentIdRoute
  PatientsPatientIdCarePlansCarePlanIdEditRoute: typeof PatientsPatientIdCarePlansCarePlanIdEditRoute
}

const PatientsPatientIdRouteChildren: PatientsPatientIdRouteChildren = {
  PatientsPatientIdLayoutRouteRoute:
    PatientsPatientIdLayoutRouteRouteWithChildren,
  PatientsPatientIdDocumentsDocumentIdRoute:
    PatientsPatientIdDocumentsDocumentIdRoute,
  PatientsPatientIdCarePlansCarePlanIdEditRoute:
    PatientsPatientIdCarePlansCarePlanIdEditRoute,
}

const PatientsPatientIdRouteWithChildren =
  PatientsPatientIdRoute._addFileChildren(PatientsPatientIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  CatalogLayoutRouteRoute: CatalogLayoutRouteRouteWithChildren,
  ChatLayoutRouteRoute: ChatLayoutRouteRouteWithChildren,
  PatientsPatientIdRoute: PatientsPatientIdRouteWithChildren,
  SettingsHotkeysRoute: SettingsHotkeysRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  PatientsIndexRoute: PatientsIndexRoute,
  ScheduleIndexRoute: ScheduleIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  CatalogDevicesDeviceIdRoute: CatalogDevicesDeviceIdRoute,
  CatalogDevicesNewRoute: CatalogDevicesNewRoute,
  CatalogDiagnosticsDiagnosticIdRoute: CatalogDiagnosticsDiagnosticIdRoute,
  CatalogDiagnosticsNewRoute: CatalogDiagnosticsNewRoute,
  CatalogExamsExamIdRoute: CatalogExamsExamIdRoute,
  CatalogExamsNewRoute: CatalogExamsNewRoute,
  CatalogFindingsFindingIdRoute: CatalogFindingsFindingIdRoute,
  CatalogFindingsNewRoute: CatalogFindingsNewRoute,
  CatalogFlowsFlowIdRoute: CatalogFlowsFlowIdRoute,
  CatalogFlowsNewRoute: CatalogFlowsNewRoute,
  CatalogLocationsLocationIdRoute: CatalogLocationsLocationIdRoute,
  CatalogLocationsNewRoute: CatalogLocationsNewRoute,
  CatalogPerformanceMeasuresQuestionnaireIdRoute:
    CatalogPerformanceMeasuresQuestionnaireIdRoute,
  CatalogPerformanceMeasuresNewRoute: CatalogPerformanceMeasuresNewRoute,
  CatalogProceduresProcedureIdRoute: CatalogProceduresProcedureIdRoute,
  CatalogProceduresNewRoute: CatalogProceduresNewRoute,
  CatalogProtocolsProtocolIdRoute: CatalogProtocolsProtocolIdRoute,
  CatalogProtocolsNewRoute: CatalogProtocolsNewRoute,
  CatalogQuestionnairesQuestionnaireIdRoute:
    CatalogQuestionnairesQuestionnaireIdRoute,
  CatalogQuestionnairesNewRoute: CatalogQuestionnairesNewRoute,
  CatalogTreatmentsTreatmentIdRoute: CatalogTreatmentsTreatmentIdRoute,
  CatalogTreatmentsNewRoute: CatalogTreatmentsNewRoute,
  ScheduleManageScheduleIdRoute: ScheduleManageScheduleIdRoute,
  ScheduleManageNewRoute: ScheduleManageNewRoute,
  TasksTaskIdReviewRoute: TasksTaskIdReviewRoute,
  CatalogFlowsIndexRoute: CatalogFlowsIndexRoute,
  ScheduleManageIndexRoute: ScheduleManageIndexRoute,
  CatalogDevicesDeviceIdEditRoute: CatalogDevicesDeviceIdEditRoute,
  CatalogDiagnosticsDiagnosticIdEditRoute:
    CatalogDiagnosticsDiagnosticIdEditRoute,
  CatalogExamsExamIdEditRoute: CatalogExamsExamIdEditRoute,
  CatalogFindingsFindingIdEditRoute: CatalogFindingsFindingIdEditRoute,
  CatalogLocationsLocationIdEditRoute: CatalogLocationsLocationIdEditRoute,
  CatalogPerformanceMeasuresQuestionnaireIdEditRoute:
    CatalogPerformanceMeasuresQuestionnaireIdEditRoute,
  CatalogProceduresProcedureIdEditRoute: CatalogProceduresProcedureIdEditRoute,
  CatalogProtocolsProtocolIdEditRoute: CatalogProtocolsProtocolIdEditRoute,
  CatalogQuestionnairesQuestionnaireIdEditRoute:
    CatalogQuestionnairesQuestionnaireIdEditRoute,
  CatalogTreatmentsTreatmentIdEditRoute: CatalogTreatmentsTreatmentIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
